import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessBoardCustomEmbedRoute: InvariantJiraRoute = {
	name: 'classic-business-board-custom-embed',
	path: '/jira/core/projects/:projectKey/board/:itemId/embed',
	exact: true,
};
